(() => {
  const initializeMediaReel = (root) => {
    if (root.dataset.mediaReelInitialized === 'true') return;

    const track = root.querySelector('[data-media-reel-track]');
    const controls = root.querySelector('[data-media-reel-controls]');
    const items = Array.from(root.querySelectorAll('[data-media-reel-item]'));

    if (!track || !controls || items.length < 2) return;

    const previous = controls.querySelector('[data-media-reel-previous]');
    const next = controls.querySelector('[data-media-reel-next]');
    const dots = Array.from(controls.querySelectorAll('[data-media-reel-dot]'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let userInteracted = false;
    let scrollFrame;

    root.dataset.mediaReelInitialized = 'true';

    const canScroll = () => track.scrollWidth > track.clientWidth + 2;

    const vibrate = () => {
      if (userInteracted && !reduceMotion.matches && typeof navigator.vibrate === 'function') {
        navigator.vibrate(8);
      }
    };

    const setActive = (index, shouldVibrate = true) => {
      const boundedIndex = Math.max(0, Math.min(index, items.length - 1));
      const changed = boundedIndex !== activeIndex;
      activeIndex = boundedIndex;

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === items.length - 1;

      if (changed && shouldVibrate) vibrate();
    };

    const scrollToItem = (index) => {
      userInteracted = true;
      const target = items[Math.max(0, Math.min(index, items.length - 1))];
      const firstOffset = items[0].offsetLeft;

      track.scrollTo({
        left: target.offsetLeft - firstOffset,
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
      setActive(index);
    };

    const updateFromScroll = () => {
      scrollFrame = undefined;
      const firstOffset = items[0].offsetLeft;
      const closestIndex = items.reduce((closest, item, index) => {
        const distance = Math.abs(item.offsetLeft - firstOffset - track.scrollLeft);
        const closestDistance = Math.abs(items[closest].offsetLeft - firstOffset - track.scrollLeft);
        return distance < closestDistance ? index : closest;
      }, 0);

      setActive(closestIndex);
    };

    const updateControls = () => {
      controls.hidden = !canScroll();
      if (!controls.hidden) updateFromScroll();
    };

    previous.addEventListener('click', () => scrollToItem(activeIndex - 1));
    next.addEventListener('click', () => scrollToItem(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => scrollToItem(index)));

    track.addEventListener('pointerdown', () => {
      userInteracted = true;
    }, { passive: true });

    track.addEventListener('touchstart', () => {
      userInteracted = true;
    }, { passive: true });

    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollToItem(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollToItem(activeIndex + 1);
      }
    });

    track.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(updateFromScroll);
    }, { passive: true });

    window.addEventListener('resize', updateControls);
    updateControls();
    setActive(0, false);
  };

  const initializeAllMediaReels = (scope = document) => {
    if (scope.matches?.('[data-media-reel]')) initializeMediaReel(scope);
    scope.querySelectorAll?.('[data-media-reel]').forEach(initializeMediaReel);
  };

  initializeAllMediaReels();
  document.addEventListener('shopify:section:load', (event) => initializeAllMediaReels(event.target));
})();
